import { isBlob } from './validator'

export const TIMEOUT = 30000
export function hasError (res = {}) {
  return +res.code !== 0
}

function isJSONBlob (blob) {
  return isBlob(blob) && blob.type === 'application/json'
}

export async function handleResponseData (errorHandler, response) {
  const { data } = response

  let result = {}

  if (isBlob(data)) {
    if (isJSONBlob(data)) {
      result = {
        code: -1,
        data,
      }
    } else {
      result = {
        code: 0,
        data,
      }
    }
  } else {
    result = {
      err: +response?.data?.code === 0 ? '' : response?.data?.message,
      ...response?.data,
      code: +response?.data?.code === 0 ? 0 : response?.data?.code,
    }
  }

  return {
    ...response,
    ...result,
  }
}

export const interceptors = { response: { handleResponseData } }
